import { formatDate, removeHtmlTags, timeFromNow } from '@utils';
import { isSameDay, isSameYear } from 'date-fns';

export const handleUserData = (to) => {
  let toString = '';
  to?.forEach((item) => {
    if (item?.linkedUserFirstName) {
      toString = `${toString} ${item?.linkedUserFirstName}`;
    }
    if (item?.linkedUserLastName) {
      toString = `${toString} ${item?.linkedUserLastName}`;
    }
    if (item?.emailAddress) {
      toString = `${toString} <${item?.emailAddress}>`;
    }
  });
  return toString;
};

export const handleEmailListViewDate = (date) => {
  if (!date) {
    return '-';
  }
  const currentDate = new Date();
  const messageDate = new Date(date);
  if (!isSameYear(currentDate, messageDate)) {
    return formatDate(date, 'dd/MM/yyyy');
  }
  if (isSameDay(currentDate, messageDate)) {
    return formatDate(date, 'HH:mm');
  }
  return formatDate(date, 'MMM dd');
};

export const getThreadPayload = ({ mailboxId, threadId }) => {
  return {
    type: 0,
    field: null,
    operator: null,
    value: [
      {
        field: 'mailboxId',
        operator: 0,
        type: 5,
        value: mailboxId,
      },
      {
        field: 'threadId',
        operator: 0,
        type: 5,
        value: threadId,
      },
    ],
  };
};

export const handleEmail = (data, mailBoxes) => {
  if (!data) {
    return {};
  }
  const content =
    data?.body &&
    data?.body?.replace?.(
      'prefers-color-scheme: dark',
      'prefers-color-scheme: light'
    );

  const mailbox = mailBoxes.find((item) => item.id === data.mailboxId);
  return {
    ...data,
    body: content,
    updatedAt: data?.updatedAt
      ? `${formatDate(data?.updatedAt)} (${timeFromNow(data?.updatedAt)})`
      : '',
    createdAt: data?.createdAt
      ? `${formatDate(data?.createdAt)} (${timeFromNow(data?.createdAt)})`
      : '',
    // date: data?.messageDate
    //   ? `${formatDate(data?.messageDate)} (${timeFromNow(data?.messageDate)})`
    //   : '',
    date: data?.messageDate
      ? `${handleEmailListViewDate(data?.messageDate)} (${timeFromNow(
          data?.messageDate
        )})`
      : '',
    // to: handleUserData(data?.to),
    cc: handleUserData(data?.cc),
    bcc: handleUserData(data?.bcc),
    ccMails: data?.cc,
    bccMails: data?.bcc,
    mailboxAddress: mailbox?.address || '',
  };
};

export const handleHistory = (data) => {
  if (!data) {
    return [];
  }
  return data?.map((item) => {
    let to = item?.to !== null ? item?.to : '-';
    if (item?.field?.includes('Assignee') && Array.isArray(item?.to)) {
      const fullName =
        item?.to.first_name && item?.to.last_name
          ? `${item?.to.first_name} ${item?.to.last_name}`
          : '';
      to = fullName || item?.to.email || item?.to.username || to._id || '';
    }
    return {
      ...item,
      to,
    };
  });
};

export const handleThreadData = (data) => {
  if (!data || !data.length) {
    return [];
  }
  const thread = [...data];
  thread.splice(thread.length - 1, 1);

  if (!thread || !thread.length) {
    return [];
  }
  const emails = thread?.map((item) => ({
    ...item,
    createdAt: item?.createdAt ? formatDate(item?.messageDate, 'MMMM dd') : '',
    messageDate: item?.messageDate
      ? `${handleEmailListViewDate(item?.messageDate)} (${timeFromNow(
          item?.messageDate
        )})`
      : '',
    updatedAt: item?.updatedAt ? formatDate(item?.updatedAt, 'MMMM dd') : '',
    assignee: item?.assignee,
    snippet: removeHtmlTags(item?.snippet),
  }));
  return emails;
};
